import React from 'react';

import { TableRow } from '@mui/material';

import Cell from '../../../common/Cell';

export default ({ item, trimText, classes, onVariableClick }) => (
  <TableRow className={classes.itemRow} onClick={() => onVariableClick(item)}>
    <Cell>{item.name}</Cell>
    <Cell>{trimText(item.en, 120)}</Cell>
    <Cell>{trimText(item.ru, 120)}</Cell>
  </TableRow>
);
